export default {
  install: (app, options) => {
    const { CustomApiService } = options;
    const { globalProperties } = app.config;
    const customApiService = new CustomApiService(app);
    globalProperties.$customApiService = () => {
      return customApiService;
    };

    if (!globalProperties.$store) {
      throw new Error("No connected store was provided");
    }
    globalProperties.$store.$customApiService =
      globalProperties.$customApiService;
  },
};
